import { FiGlobe, FiInstagram, FiMusic, FiYoutube } from "react-icons/fi";
import { normalizeExternalUrl } from "../../utils/profileLinks";

function ProfileSocialLinks({ profile }) {
  const links = [
    { key: "instagram", label: "Instagram", value: profile.instagram, icon: <FiInstagram /> },
    { key: "youtube", label: "YouTube", value: profile.youtube, icon: <FiYoutube /> },
    { key: "tiktok", label: "TikTok", value: profile.tiktok, icon: <FiMusic /> },
    { key: "website", label: "Website", value: profile.website, icon: <FiGlobe /> }
  ].filter((item) => String(item.value || "").trim());
  if (!links.length) return null;
  return <section className="profile-socials" aria-labelledby="profile-connect-title"><h2 id="profile-connect-title" className="mybuildid-section-heading">Connect</h2><div>{links.map((link) => <a key={link.key} href={normalizeExternalUrl(link.value, link.key)} target="_blank" rel="noopener noreferrer">{link.icon}<span>{link.label}</span></a>)}</div></section>;
}
export default ProfileSocialLinks;
